import { isClinro, isLocal } from '@/config';
import { EnvRegion, getEnvConfig, localAPIUrl } from '@/config/env';
import { REGEX, getLocalStorage } from './helpers';
const host = window.location.hostname;
export function isUrlExternal(url) {
    if (!url) {
        return false;
    }
    const linkHost = ((url) => {
        if (/^https?:\/\//.test(url)) {
            // The easiest way to parse an URL is to create <a> element.
            // Based on: https://github.com/mrded/is-url-external
            const parser = document.createElement('a');
            parser.href = url;
            return parser.hostname;
        }
        // Get the relative URL
        return window.location.hostname;
    })(url);
    return host !== linkHost;
}
export function isUrlSpecial(url) {
    if (!url) {
        return false;
    }
    const commonUrlSchemes = ['data:', 'fax:', 'file:', 'geo:', 'info:', 'magnet:', 'mailto:', 'tel:'];
    return commonUrlSchemes.filter((prefix) => url.startsWith(prefix)).length > 0;
}
export const resolveWebViewUrl = (request) => {
    var _a, _b, _c;
    if ('path' in request) {
        const path = (_b = (_a = request.path) === null || _a === void 0 ? void 0 : _a.replace(REGEX.LEADING_SLASHES, '')) !== null && _b !== void 0 ? _b : '';
        const studyUrl = getLocalStorage().api_url || window.location.origin;
        const baseUrl = studyUrl.replace(REGEX.TRAILING_SLASHES, '');
        return `${baseUrl}/${path}`;
    }
    return 'url' in request ? ((_c = request.url) !== null && _c !== void 0 ? _c : '') : '';
};
export const buildAPIUrl = (studyCode) => {
    const { ENV_NAME } = getEnvConfig();
    const studyIdentifier = studyCode.slice(0, 5);
    const regionNumber = Number(studyCode.slice(5, 6));
    const regionCode = EnvRegion[regionNumber];
    const tld = regionCode === 'cn' ? 'cn' : 'io';
    const apiURL = isClinro
        ? window.location.origin
        : isLocal
            ? localAPIUrl
            : `https://${studyIdentifier}-${regionCode}.${ENV_NAME}.umotif.${tld}`;
    return {
        apiURL,
        isRegionCodeValid: !!regionCode,
        regionCode,
        regionNumber,
        studyIdentifier
    };
};
export const createQueryParams = (params) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        query.append(key, value != null ? value.toString() : '');
    });
    return query.toString() ? `?${query.toString()}` : '';
};
export function generateRoute(route, params) {
    return Object.entries(params).reduce((result, [key, value]) => result.replace(`:${key}`, String(value)), route);
}
